import { ValueGetterParams } from "ag-grid-community";
import { BudgetWithIntegrations } from "@/store/budgets/utils/types/common";

export const budgetNameFilterValueGetter = ({
  data,
}: ValueGetterParams<BudgetWithIntegrations>) => data?.name ?? "";
